import { ref, computed, onMounted } from "vue";
import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";
import { useSystemStore } from "@/stores/system";
import router from "../router";

export const useAuthStore = defineStore("auth", () => {
  const httpStore = useHttpStore();
  const systemStore = useSystemStore();

  const userAuthorized = ref(false);

  onMounted(() => {
    
  });

  const login = (username, password) => {
    var params = {
      Username: username,
      Password: password,
    };
    try {
      return new Promise((resolve, reject) => {
        httpStore
          .api("post", "accounts/login", params, { showLoading: true })
          .then((res) => {
            if (res.success === true) {
              var ast = systemStore.getData("assets");
              ast.ua = 1;
              ast.otp = ast.otp === 1 ? 1 : 0;
              systemStore.setData("assets", ast);
            }
  
            sessionStorage.setItem("accessToken", res.accessToken);
  
            httpStore.token = res.accessToken;
            systemStore.userDetail = res.userDetail;
            resolve(res);
          })
          .catch((error) => {
            console.log('auth 1', error)
            reject(error);
          });
      });
    } catch (error) {
      console.log('auth 2', error)
    }
    
  };

  const hCaptchaSiteVerify = (challengeToken) => {
    var params = {
      clientResponse: challengeToken,
    };
    try {
      return new Promise((resolve, reject) => {
        httpStore
          .api("post", "accounts/captchaSiteVerify", params, { showLoading: true })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log('auth 3', error)
            reject(error);
          });
      });
    } catch (error) {
      console.log('auth 4', error)
    }
  };

  const verifyOtp = (otpInput) => {
    var params = {
      otp: otpInput,
    };
    try {
      var ast = systemStore.getData("assets");
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "accounts/verifyOtp", params, { showLoading: true })
        .then((res) => {
          if (res.success === true){           
            ast.otp = 1            
          } else {
            ast.otp = 0
          }
          systemStore.setData('assets', ast);
          resolve(res);
        })
        .catch((error) => {
          console.log('auth 5', error)
          ast.otp = 0
          systemStore.setData('assets', ast);
          reject(error);
        });
    });
    } catch (error) {
      console.log('auth 6', error)
    }
    
  };

  const verifyOtpEmail = (otp, username, password) => {
    var params = {
      otp,
      username,
      password
    };
    try {
      var ast = systemStore.getData("assets");
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "accounts/verifyOtpEmail", params, { showLoading: true })
        .then((res) => {
          if (res.success === true){           
            ast.otp = 1            
          } else {
            ast.otp = 0
          }
          systemStore.setData('assets', ast);
          resolve(res);
        })
        .catch((error) => {
          console.log('auth 7', error)
          reject(error);
        });
    });
    } catch (error) {
      console.log('auth 8', error)
    }
    
  };

  const verifyOtpEmailForgotPassword = (otp, username) => {
    var params = {
      otp,
      username
    };
    try {
      var ast = systemStore.getData("assets");
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "accounts/VerifyOtpEmailForgotPassword", params, { showLoading: true })
        .then((res) => {
          if (res.success === true){           
            ast.otp = 1            
          } else {
            ast.otp = 0
          }
          systemStore.setData('assets', ast);
          resolve(res);
        })
        .catch((error) => {
          console.log('auth 9', error)
          reject(error);
        });
    });
    } catch (error) {
      console.log('auth 10', error)
    }
    
  };

  const sendOtpEmail = (username) => {
    var params = {};

    try {
      return new Promise((resolve, reject) => {
        httpStore
          .api("post", "accounts/SendOtpEmail", params, { showLoading: true })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log('auth 11', error)
            reject(error);
          });
      });
    } catch (error) {
      console.log('auth 12', error)
    }
    
  };

  const sendEmailVerificationOtp = (username) => {
    var params = {
      username,
    };
    try {
      return new Promise((resolve, reject) => {
        httpStore
          .api("post", "accounts/SendEmailVerificationOtp", params, {
            showLoading: true,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log('auth 13', error)
            reject(error);
          });
      });
    } catch (error) {
      console.log('auth 14', error)
    }
    
  };

  const getTotpQrCode = () => {
    var params = {};
    try {
      return new Promise((resolve, reject) => {
        httpStore
          .api("get", "accounts/getTotpQrCode", params, { showLoading: true })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log('auth 14', error)
            reject(error);
          });
      });
    } catch (error) {
      console.log('auth 15', error)
    }
    
  };

  const isFirstLogin = (username) => {
    var params = {
      EmailAddress: username,
    };
    try {
      return new Promise((resolve, reject) => {
        httpStore
          .api("post", "accounts/isFirstLogin", params, { showLoading: true })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log('auth 16', error)
            reject(error);
          });
      });
    } catch (error) {
      console.log('auth 17', error)
    }

    
  };

  const submitForgotPasswordUpdate = (username, password, secret) => {
    var params = {
      username,
      password,
      secret
    };
    try {
      return new Promise((resolve, reject) => {
        httpStore
          .api("post", "accounts/SubmitForgotPasswordUpdate", params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log('auth 18', error)
            reject(error);
          });
      });
    } catch (error) {
      console.log('auth 19', error)
    }
    
  };

  const logout = () => {
    sessionStorage.setItem("accessToken", "");

    httpStore.token = "";
    userAuthorized.value = false;
    router.push({ name: "login" });
  };

  const xrequest = (id) => {
    var params = {
      X: id
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "accounts/XRequest", params, { showLoading: true })
        .then((res) => {
          if (res.success === true) {
            var ast = systemStore.getData("assets");
            ast.ua = 1;
            ast.otp = 1;
            systemStore.setData("assets", ast);
          }

          sessionStorage.setItem("accessToken", res.accessToken);

          httpStore.token = res.accessToken;
          systemStore.userDetail = res.userDetail;
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const impersonateUser = (username) => {
    var params = {
      Username: username,
      Password: '',
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "accounts/ImpersonateUser", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    userAuthorized,
    login,
    logout,
    hCaptchaSiteVerify,
    verifyOtp,
    verifyOtpEmail,
    verifyOtpEmailForgotPassword,
    getTotpQrCode,
    isFirstLogin,
    sendEmailVerificationOtp,
    sendOtpEmail,
    submitForgotPasswordUpdate,
    impersonateUser,
    xrequest
  };
});
